import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var FlagSwallowtailSVG = function FlagSwallowtailSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M29.8 20.4L24.3 13l5.5-6.4a1 1 0 00.1-1A1 1 0 0029 5H6V4a1 1 0 00-2 0v5H3a1 1 0 000 2h1v5H3a1 1 0 000 2h1v10a1 1 0 002 0v-6h23a1 1 0 00.8-1.6zM8 18H6v-2h2a1 1 0 010 2zm0-7H6V9h2a1 1 0 010 2z"
  }));
};
FlagSwallowtailSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FlagSwallowtailSVG);